import { OrdersState } from './types'

export const initialState: OrdersState = {
  orders: [],
  filters: {
    page: 1,
    limit: 10
  },
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  listLoading: false,
  listError: null,
  
  orderCache: {},
  orderLoading: false,
  orderError: null,
  currentOrderId: null
}

